<template>
    <!--<VueDatePicker
        v-model="bookingDate"
        :min-date="minDate"
        :is-24="is24"
        :enable-time-picker="timePicker"
        :clearable="clearable"
        :minutes-grid-increment="minutesGridIncrement"
        :minutes-increment="minutesIncrement"
        :format="format"
        :allowed-dates="allowedBookingDates"
        :markers="handymanMarkers"
    ></VueDatePicker>-->
    <VueDatePicker
        v-model="bookingDate"
        :is-24="is24"
        :enable-time-picker="timePicker"
        :clearable="clearable"
        :minutes-grid-increment="minutesGridIncrement"
        :minutes-increment="minutesIncrement"
        :format="format"
        :markers="handymanMarkers"
        :disabled="disabled"
        :timezone="timezone"
        :auto-apply="autoApply"
        :min-date="minDate ? minDate : null"
        @closed="datePickerClosed"
    ></VueDatePicker>
</template>
<script>
import moment from 'moment';
export default {
    props: {
        modelValue: {
            default: new Date(),
        },
        // Add other VueDatePicker props here
        minDate: {
            type: [Date, String],
            default: null,
        },
        is24: {
            type: Boolean,
            default: false,
        },
        minutesGridIncrement: {
            type: Number,
            default: 10,
        },
        minutesIncrement: {
            type: Number,
            default: 15,
        },
        format: {
            type: String,
            default: 'dd-MM-yyyy',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        timePicker: {
            type: Boolean,
            default: true,
        },
        displayMarker: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        timezone: {
            type: String,
            default: 'UTC',
        },
        location: {
            type: String,
            default: 'order',
        },
        autoApply: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            bookingDate: this.modelValue,
            //handymanSchedules: [],
            allowedBookingDates: [],
            handymanMarkers: [],
        };
    },
    mounted() {
        //this.getHandymanSchedules();

        //Received event to refresh schedules
        this.$emitter.on('hmRefreshSchedules', () => {
            //this.getHandymanSchedules();
        });
        this.prepareBookingDatePickerOptions();
    },
    computed: {
        handymanSchedules() {
            let schedules = this.$store.state.availableSchedules;
            //this.$emitter.emit('hmSchedulesFetched', {schedules: schedules});
            return schedules;
        }
    },
    methods: {
        /* getHandymanSchedules() {
            let self = this;
            axios.post("/admin/handymans/get-hm-schedules", {location: this.location})
                .then((response) => {
                    self.handymanSchedules = response.data.schedules;

                    self.$emitter.emit('hmSchedulesFetched', {schedules: self.handymanSchedules});
                });
        }, */
        prepareBookingDatePickerOptions() {
            let self = this;
            const availableDates = [];
            Object.keys(this.handymanSchedules).forEach((handymanId) => {
                this.handymanSchedules[handymanId].forEach((schedule) => {
                    availableDates.push(schedule.schedule_date);
                });
            });

            this.allowedBookingDates = [...new Set(availableDates)];

            // Prepare the calendar markers for the available dates
            if (this.$props.displayMarker) {
                Object.keys(this.handymanSchedules).forEach((handymanId) => {
                    this.handymanSchedules[handymanId].forEach((schedule) => {
                        let existIndex = self.handymanMarkers.findIndex(function(option) {
                            return option.format_date === schedule.schedule_date;
                        });

                        // If it doesn't exist, push the new option
                        // else push the handyman into the tooltip
                        if (existIndex === -1)  {
                            self.handymanMarkers.push({
                                format_date: schedule.schedule_date,
                                date: moment(schedule.schedule_date),
                                type: 'dot',
                                //tooltip: [
                                //    { text:  schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')'},
                                //],
                            });
                        }
                        else {
                            //self.handymanMarkers[existIndex].tooltip.push({ text:  schedule.full_name + ' (' + moment(schedule.start_time, 'HH:mm:ss').format('hh:mm A') + ' - ' + moment(schedule.end_time, 'HH:mm:ss').format('hh:mm A') + ')'});
                        }
                    });
                });
            }
        },
        datePickerClosed() {
            //console.log('datePickerClosed');
        },
        handleDateSelect() {
            this.$emitter.emit('calendarDateSelected', {date: this.bookingDate});
        }
    },
    watch: {
        modelValue(newVal) {
            this.bookingDate = newVal;
            this.handleDateSelect();
        },
        bookingDate(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        handymanSchedules(newSchedules, oldSchedules) {
            // this.$emitter.emit('hmSchedulesFetched', {schedules: newSchedules});
            this.prepareBookingDatePickerOptions();
        }
    },
};
</script>
